export const isWindowsOS = () => {
  return navigator.appVersion.indexOf("Win") !== -1;
};

export const desclaimerMessage =
  "If restrictions are set at both the parent rate plan and promo level, the most restrictive will apply. To use less restrictive conditions, update them in the parent rate plan or CRS.";

export const infoMessage =
  "if the parent rate plan has a minimum lead-time restriction of 14 nights, and the promo is created with a  minimum lead-time restriction of 3 nights, the 14-nights will apply.";
